import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Modal } from "react-bootstrap";
import { deleteMyAccount } from "../../../../api/users";
import { Spinner } from "react-bootstrap";
import { log_error } from "../../../../api";

const DeletionConfirmModal = ({ user, show, hide, showDeletionSubscribtionModal }) => {
  let [loading, setLoading] = useState(false);

  const handleDeletion = async () => {
    try {
      setLoading(true);
      await deleteMyAccount(user.id);
      showDeletionSubscribtionModal();
      window.href("/login");
    } catch (error) {
      console.log(log_error(error));
    } finally {
      setLoading(false);
    }
  };
  return (
    <Modal className="unsubscribe-primo-modal" show={show} onHide={hide} animation={true}>
      <Modal.Body className="text-center p-4 m-3">
        <p className="text-uppercase">{`Delete my account`}</p>
        <small>
          This will permanently delete your account for UNIFI Music, including all content, images, posts, albums, and songs you've added.
        </small>

        <p className="text-uppercase">{`Are you sure?`}</p>

        <div className="d-flex justify-content-center mt-3">
          <button onClick={hide} type="reset" className="btn btn-outline-primary btn-md mr-3">
            Cancel
          </button>
          <button type="submit" disabled={loading} className="btn btn-primary btn-md" onClick={() => handleDeletion()}>
            {loading ? <Spinner size="sm" animation="border" role="status" /> : "Delete"}
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default DeletionConfirmModal;
